/**
 * Query-key factory for the auth feature. Features never hand-spell keys at
 * the call site — always reach for the factory so invalidations stay exact.
 */
export const authKeys = {
  all: ['auth'] as const,
  me: () => [...authKeys.all, 'me'] as const,
};
